<template>
  <DialogModal
    :show="isLoginModal"
    max-width="xl"
    extra-flex="flex justify-center items-center"
    header-class="modal-padding"
    extra-class="login-modal custom-scroll"
    @close="closeLoginModal"
  >
    <template #content>
      <div class="p-4 pt-0">
        <ModalLogin
          :is-modal-login="'true'"
          :useremail="email"
          @close="closeLoginModal"
        />
      </div>
    </template>
  </DialogModal>
</template>

<script>
import DialogModal from "@/Jetstream/DialogModal.vue";

import ModalLogin from "@/components/Template/SharedLaunch/ModalLogin.vue";
export default {
   
   name: "LoginModel",
   components: {
      DialogModal,
      ModalLogin
   },
   props: {
      isLoginModal: {
         type: Boolean,
         required: false,
      },
      email: {
         type: String,
         required: false,
      }
   },
   methods:{
      closeLoginModal(userId = '') {
         this.$emit("close_login_modal", userId);
      },
   }
}
</script>
<style scoped>

</style>